import React, { memo, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  HeaderLayout,
  HeaderTop,
  HeaderBrand,
  CategoryNav,
  CategoryButton,
  SubMenuPanel,
  MenuLink,
} from "./PCHeader.style";
import { getMenuCategories, isMenuPathActive } from "../../MainMenu.config";
import FW from "../../../../../config/word.json";
import headerLogo from "../../../../../pages/Login/DX_Jankatsu_Master_Logo.svg";

const PCHeader = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const userFlg = sessionStorage.getItem("userFlg");
  const categories = getMenuCategories(userFlg);
  const activeKey = categories.find((category) =>
    category.items.some((item) => isMenuPathActive(pathname, item.path)),
  )?.key;
  const [openKey, setOpenKey] = useState(activeKey ?? "base");
  const categoryRefs = useRef({});
  const openCategory = categories.find((category) => category.key === openKey);
  const showMenu =
    ["9", "8", "7"].includes(userFlg) && !pathname.includes("notice");

  useEffect(() => {
    setOpenKey(activeKey ?? "base");
  }, [pathname, activeKey]);

  const closeOnEscape = (event) => {
    if (event.key === "Escape" && openKey) {
      event.preventDefault();
      categoryRefs.current[openKey]?.focus();
      setOpenKey(null);
    }
  };

  return (
    <HeaderLayout onKeyDown={closeOnEscape}>
      <HeaderTop>
        <HeaderBrand>
          <img
            src={headerLogo}
            alt={FW.F_W_LOGIN_T1}
            width="240"
          />
        </HeaderBrand>
        {showMenu && (
          <CategoryNav aria-label="メインメニュー">
            {categories.map((category) => {
              const isOpen = openKey === category.key;
              return (
                <CategoryButton
                  key={category.key}
                  ref={(element) => {
                    categoryRefs.current[category.key] = element;
                  }}
                  id={`pc-category-${category.key}`}
                  type="button"
                  $active={activeKey === category.key}
                  $open={isOpen}
                  aria-expanded={isOpen}
                  aria-controls={
                    isOpen ? `pc-submenu-${category.key}` : undefined
                  }
                  onClick={() => {
                    const firstPath = category.items[0]?.path;
                    if (isOpen && pathname === firstPath) {
                      setOpenKey(null);
                      return;
                    }
                    setOpenKey(category.key);
                    if (firstPath) navigate(firstPath);
                  }}
                >
                  {category.title}
                  <span aria-hidden="true">{isOpen ? "▴" : "▾"}</span>
                </CategoryButton>
              );
            })}
          </CategoryNav>
        )}
      </HeaderTop>
      {showMenu && openCategory && (
        <SubMenuPanel
          id={`pc-submenu-${openKey}`}
          aria-labelledby={`pc-category-${openKey}`}
        >
          {openCategory.items.map((item) => {
            const active = isMenuPathActive(pathname, item.path);
            return (
              <MenuLink
                key={item.path}
                to={item.path}
                aria-current={active ? "page" : undefined}
                onClick={() => {
                  if (item.path === "/") sessionStorage.clear();
                }}
              >
                <span aria-hidden="true">
                  {active ? item.icon : (item.clickedIcon ?? item.icon)}
                </span>
                {item.title}
              </MenuLink>
            );
          })}
        </SubMenuPanel>
      )}
    </HeaderLayout>
  );
};

export default memo(PCHeader);
